import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TextEditorComponent, MentionData } from '../../../shared/public-api';

@Component({
  selector: 'admin-mention-section',
  templateUrl: './mention-section.component.html',
  styleUrls: ['./mention-section.component.scss'],
  imports: [CommonModule, FormsModule, TextEditorComponent],
})
export class MentionSectionComponent implements OnInit {
  @Input() sectionData: MentionData;
  @Output() sectionDataChange = new EventEmitter<any>();

  ngOnInit(): void {
    if (!this.sectionData) {
      this.sectionData = new MentionData();
    }
  }
}
